


































import { Component, Vue, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import ScoutingGroup from "@/models/ScoutingGroup";

@Component({
  components: {
    VModal,
  },
})
export default class GroupDeleteModal extends Vue {
  @Ref() readonly modal!: VModal;
  scoutingGroup: ScoutingGroup | null = null;

  show(scoutingGroup: ScoutingGroup) {
    this.scoutingGroup = scoutingGroup;
    this.modal.show();
  }

  onCancel() {
    this.modal.hide();
  }

  onDelete() {
    this.modal.hide();
    this.$emit("delete", this.scoutingGroup);
  }
}
